<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="countryCharCode" label="国家二字码" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.countryCharCode" placeholder="请输入" v-trim />
      </a-form-item>
      <a-form-item name="countryCnName" label="国家中文名" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.countryCnName" placeholder="请输入" v-trim />
      </a-form-item>
      <a-form-item name="countryEnName" label="国家英文名" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.countryEnName" placeholder="请输入" v-trim />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { adminAreaSave, adminAreaUpdate } from '@/api/overseasSales/administrativeRegion'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import { adminAreaSaveParams } from '@/typings/api/overseasSales'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<adminAreaSaveParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: adminAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = editForm.value
    try {
      if (editForm.value.id) {
        await adminAreaUpdate({
          ...p,
          id: editForm.value.id,
          level: 1,
          name: editForm.value.countryCnName,
          fullName: editForm.value.countryCnName
        })
      } else {
        await adminAreaSave({
          ...p,
          parentId: '-1',
          level: 1,
          name: editForm.value.countryCnName,
          fullName: editForm.value.countryCnName
        })
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
